/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscriptionalertpaymentpendingtitle4Inputs */



/**
* | output |
* | --- |
* | "Payment is processing" |
*
* @param {Subscriptionalertpaymentpendingtitle4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscriptionalertpaymentpendingtitle4 = /** @type {((inputs?: Subscriptionalertpaymentpendingtitle4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscriptionalertpaymentpendingtitle4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Payment is processing")
	if (locale === "es") return /** @type {LocalizedString} */ ("El pago se está procesando")
	return /** @type {LocalizedString} */ ("Оплата обрабатывается")
});
export { subscriptionalertpaymentpendingtitle4 as "subscriptionAlertPaymentPendingTitle" }